/** basic-with-title */

<template>
    <div class="legend-item-with-title">
        <div>
            <label>
                <input type="checkbox" class="legend-checkbox" v-if="layer.allow_control" v-model="checkboxState"/> {{ layer.layer_name_display }}
            </label>
        </div>

        <div class="legend-item-below-title" v-if="!layer.allow_control || checkboxState">
            <div><img v-bind:src="layer.legend_graphic" alt=""></div>
            <div v-if="layer.legend_additional_text" v-html="layer.legend_additional_text"></div>
        </div>

    </div>
</template>


<script>
export default {
    name: "basic-with-title",
    components: {},
    props: {
        layer: {type: Object, required: true}
    },
    data: function () {
        return {
            checkboxState: false
        }
    },
    methods: {
        emitStateChange: function () {
            this.$emit("layer-change", ["single", this.layer.layer_name, this.checkboxState])
        }
    },
    computed: {},
    watch: {},
    mounted: function () {
        this.checkboxState = this.layer.start_enabled;
        this.$watch("checkboxState", this.emitStateChange);  // add the watcher here to avoid firing on initial setup - https://stackoverflow.com/a/58949762/
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .legend-item-with-title {
        margin-bottom: 5px;

        > div {
            width: 100%;
            display: inline-block;

            &:first-of-type {
                //font-weight: bold;
                height: 20px;

                input[type=checkbox] {
                    margin-right: 1px;
                }
            }
        }

        .legend-item-below-title {
            display: flex;
            justify-content: flex-start;
            margin-top: 2px;

            > div:first-of-type {
                display: flex;
                flex: 0 0 20px;
                margin-left: 20px;
            }
        }
    }
</style>